import AppRecord from './AppRecord.js'
import APP from '../../../main.js'

class MeetingSummary extends AppRecord {
  get datetime(){
    if(this.time){
      return this.date + ' ' + this.time + " UTC"
    } else {
      return this.date
    }
  }
  get people(){
    if(this._people){return this._people}
    return this._people = this.constructor.employeeStore.people.filter(per => this.participant_ids.includes(per.id))
  }
  set people(collection){
    this._people = null
    this.participant_ids = [...new Set(collection.map(item=>item.id))]
  }
  get user(){
    return this.constructor.employeeStore.users.find(usr => usr.id === this.user_id)
  }
  get user_name(){
    if(this.user){return this.user.name}
    return null
  }
  get owner(){
    if(this.user){
      return this.constructor.employeeStore.peopleById.get(this.user.person_id)
    } else {
      return undefined
    }
  }
  get communication_type_label(){
    let item = this.constructor.employeeStore.communication_types.find(typ => typ.value === this.communication_type)
    return (item || {label: "TILFØJ KOMM. FORM!"}).label
  }
  get grant_show_on_roles_label(){
    let roles = this.constructor.employeeStore.roles.filter(typ => this.grant_show_on_roles.includes(typ.role))
    return roles.map(r=>r.label)
  }
}

export default MeetingSummary
